


export const OverAll_Sentiment_Metric = {
    guid: 'f090fad6-f869-4a87-a137-455160de6968',
    score: 0,
    valid: true,
    overAllSentiment: true,
    tag: 'Sentiment',
    highThreshold: {
        max: 33, min: 0
    },
    lowThreshold: {
        max: 100, min: 66
    },
    mediumThreshold: {
        max: 66, min: 33
    }
}